import React from 'react';
import { EventWithId } from '../../hooks/useEvents';
import EventCard from './EventCard';
import EmptyState from './EmptyState';

interface EventListProps {
    events: EventWithId[];
    filteredEvents: EventWithId[];
    copiedEventId: string | null;
    onShareLink: (eventId: string) => void;
    onClearFilters: () => void;
    onDeleteEvent?: (eventId: string) => Promise<void>;
    onRemoveHistory?: (eventId: string) => Promise<void>;
    currentUserId?: string;
    totalEventCount?: number;
    // Shared status map from the page's single `eventList` listener, so each
    // card does not open one of its own.
    eventStatusMap: Record<string, boolean>;
}

const EventList: React.FC<EventListProps> = ({
                                                 events,
                                                 filteredEvents,
                                                 copiedEventId,
                                                 onShareLink,
                                                 onClearFilters,
                                                 onDeleteEvent,
                                                 onRemoveHistory,
                                                 currentUserId,
                                                 totalEventCount,
                                                 eventStatusMap
                                             }) => {

    const hasAnyEvents = totalEventCount !== undefined ? totalEventCount > 0 : events.length > 0;

    if (filteredEvents.length === 0) {
        return (
            <EmptyState
                type={hasAnyEvents ? 'no-results' : 'no-events'}
                onClearFilters={onClearFilters}
            />
        );
    }

    return (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-stretch">
            {filteredEvents.map((event) => (
                <EventCard
                    key={event.id}
                    event={event}
                    copiedEventId={copiedEventId}
                    onShareLink={onShareLink}
                    onDeleteEvent={onDeleteEvent}
                    onRemoveHistory={onRemoveHistory}
                    currentUserId={currentUserId}
                    isClosed={!eventStatusMap[event.id]}
                />
            ))}
        </div>
    );
};

export default EventList;